var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crud-wrapper"},[_c('crud',{ref:"crud",attrs:{"form-component":_vm.pendingAffiliatesForm,"grid-columns":_vm.gridColumns,"grid-options":_vm.gridOptions,"gridSettings":{noNew: true},"obj":"pendingAffiliate"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ed2024e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PendingAffiliates.vue
// module id = null
// module chunks = 